import {Component} from '@angular/core';

@Component({
    selector: 'app-footer',
    template: `
      <div class="layout-footer">
        <div class="clearfix">
          <span class="footer-text-left">Copyright &copy; 2022, Hinnovation. </span>
          <span class="footer-text-right">All Rights Reserved</span>
        </div>
      </div>
    `
})
export class AppFooterComponent {

}



// WEBPACK FOOTER //
// ./src/app/app.footer.component.ts